/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SharedSettlement } from './SharedSettlement';
import {
    SharedSettlementFromJSON,
    SharedSettlementFromJSONTyped,
    SharedSettlementToJSON,
    SharedSettlementToJSONTyped,
} from './SharedSettlement';
import type { ActionEnum } from './ActionEnum';
import {
    ActionEnumFromJSON,
    ActionEnumFromJSONTyped,
    ActionEnumToJSON,
    ActionEnumToJSONTyped,
} from './ActionEnum';
import type { BookingTerms } from './BookingTerms';
import {
    BookingTermsFromJSON,
    BookingTermsFromJSONTyped,
    BookingTermsToJSON,
    BookingTermsToJSONTyped,
} from './BookingTerms';

/**
 *
 * @export
 * @interface BookingChanges
 */
export interface BookingChanges {
    /**
     *
     * @type {ActionEnum}
     * @memberof BookingChanges
     */
    action: ActionEnum;
    /**
     *
     * @type {string}
     * @memberof BookingChanges
     */
    stage?: string;
    /**
     *
     * @type {Date}
     * @memberof BookingChanges
     */
    holdDate?: Date;
    /**
     *
     * @type {BookingTerms}
     * @memberof BookingChanges
     */
    bookingTerms?: BookingTerms;
    /**
     *
     * @type {SharedSettlement}
     * @memberof BookingChanges
     */
    sharedSettlement?: SharedSettlement;
    /**
     *
     * @type {string}
     * @memberof BookingChanges
     */
    loadInTime?: string | null;
    /**
     *
     * @type {string}
     * @memberof BookingChanges
     */
    soundcheckTime?: string | null;
    /**
     *
     * @type {string}
     * @memberof BookingChanges
     */
    doorsTime?: string | null;
    /**
     *
     * @type {string}
     * @memberof BookingChanges
     */
    showTime?: string | null;
    /**
     *
     * @type {string}
     * @memberof BookingChanges
     */
    endTime?: string | null;
    /**
     *
     * @type {number}
     * @memberof BookingChanges
     */
    showCapacity?: number | null;
    /**
     *
     * @type {number}
     * @memberof BookingChanges
     */
    attendance?: number | null;
}



/**
 * Check if a given object implements the BookingChanges interface.
 */
export function instanceOfBookingChanges(value: object): value is BookingChanges {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function BookingChangesFromJSON(json: any): BookingChanges {
    return BookingChangesFromJSONTyped(json, false);
}

export function BookingChangesFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingChanges {
    if (json == null) {
        return json;
    }
    return {

        'action': ActionEnumFromJSON(json['action']),
        'stage': json['stage'] == null ? undefined : json['stage'],
        'holdDate': json['hold_date'] == null ? undefined : (new Date(json['hold_date'])),
        'bookingTerms': json['booking_terms'] == null ? undefined : BookingTermsFromJSON(json['booking_terms']),
        'sharedSettlement': json['shared_settlement'] == null ? undefined : SharedSettlementFromJSON(json['shared_settlement']),
        'loadInTime': json['load_in_time'] == null ? undefined : json['load_in_time'],
        'soundcheckTime': json['soundcheck_time'] == null ? undefined : json['soundcheck_time'],
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'showCapacity': json['show_capacity'] == null ? undefined : json['show_capacity'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
    };
}

  export function BookingChangesToJSON(json: any): BookingChanges {
      return BookingChangesToJSONTyped(json, false);
  }

  export function BookingChangesToJSONTyped(value?: BookingChanges | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'action': ActionEnumToJSON(value['action']),
        'stage': value['stage'],
        'hold_date': value['holdDate'] == null ? undefined : ((value['holdDate']).toISOString().substring(0,10)),
        'booking_terms': BookingTermsToJSON(value['bookingTerms']),
        'shared_settlement': SharedSettlementToJSON(value['sharedSettlement']),
        'load_in_time': value['loadInTime'],
        'soundcheck_time': value['soundcheckTime'],
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'show_capacity': value['showCapacity'],
        'attendance': value['attendance'],
    };
}
